import React, { createContext, useContext, useState, useEffect } from 'react';

const CROQEE_SERVER_URL = process.env.REACT_APP_CROQEE_SERVER_URL || 'https://croqeeserver.online';
const CONNECTION_CHECK_INTERVAL = 30000; // 30 seconds

interface ConnectionContextType {
  isOffline: boolean;
  checkConnection: () => Promise<void>;
}

const ConnectionContext = createContext<ConnectionContextType>({
  isOffline: false,
  checkConnection: async () => {},
});

export const useConnection = () => useContext(ConnectionContext);

export const ConnectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOffline, setIsOffline] = useState(false);

  const checkConnection = async () => {
    try {
      const response = await fetch(`${CROQEE_SERVER_URL}`);
      if (!response.ok) {
        throw new Error('Server is not responding');
      }
      setIsOffline(false);
    } catch (error) {
      setIsOffline(true);
    }
  };

  useEffect(() => {
    checkConnection();
    const interval = setInterval(checkConnection, CONNECTION_CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return (
    <ConnectionContext.Provider value={{ isOffline, checkConnection }}>
      {children}
    </ConnectionContext.Provider>
  );
}; 